import React, { useEffect } from "react";
import "./Material.css";
import Common_Title from "../common_components/common_title/Common_Title";
import { useDispatch, useSelector } from "react-redux";
import { AllShape } from "../../features/master/masterSlice";
import Common_Material_Card from "../common_components/common_material_card/Common_Material_Card";

function Material() {
  const shopbymaterial = useSelector((state) => state?.master?.shape || []);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  return (
    <>
      <section className="Material Shop_By_Material">
        <div className="container">
          <div className="main_div">
            <Common_Title title={"Explore By Material"} />

            <div className="main_content_div">
              <div className="row">
                {/* LEFT COLUMN → first 3 items */}
                {shopbymaterial.map((item) => (
                  <div className="col-md-6 mb-4" key={item.id}>
                    <div className="left_div">
                      <div className="material_div">
                        <Common_Material_Card
                          title={item?.name}
                          imgScr={process.env.REACT_APP_IMG_URL + item?.image}
                          shape_id={item?.id}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Material;
